export default __webpack_public_path__ + "static/media/terms-signup.0b45632c.jpg";